export default "__VITE_ASSET__7hjIbePz__"